import React, { Component } from "react";
import { Icon } from "react-materialize";
import NuxeoClient from "../../clients/NuxeoClient";

import "./SubmissionDownloadButton.css";

class SubmissionDownloadButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.submissionId,
      isDownloading: false,
    };

    this._getAllFilesAndDownload = this._getAllFilesAndDownload.bind(this);
    this._downloadFinished = this._downloadFinished.bind(this);
  }

  _downloadFinished = () => {
    console.info("Done");
    this.setState({ isDownloading: false });
  };

  _getAllFilesAndDownload = (id) => {
    NuxeoClient.instance()
      .getArchivedSubmissionAssociatedFiles(id)
      .then((associatedFiles) => {
        let allFileObjects = associatedFiles;

        if (associatedFiles) {
          let allFileList = [];

          allFileObjects["All Files"].map((file) => allFileList.push(file.uid));
          if (allFileList.length === 0) {
            window.Materialize.toast("No Assets Found...", 2000);
            return;
          }
          this.setState({ isDownloading: true });
          NuxeoClient.instance().startBulkDownload(
            `${id}.zip`,
            allFileList,
            this._downloadFinished
          );
        }
      });
  };

  render() {
    return (
      <div>
        <div
          className="download-button"
          onClick={() => {
            this._getAllFilesAndDownload(this.state.id);
          }}>
          <Icon small>file_download</Icon>
        </div>
        <div>{this.state.isDownloading === true ? "Downloading..." : ""}</div>
      </div>
    );
  }
}

export default SubmissionDownloadButton;
